export default {
  title: 'Atualização de hora!',
  labels: {
    old_time: 'Hora de recolha anterior:',
    new_time: 'Nova hora de recolha:',
    old_serve_time: 'Hora de serviço anterior:',
    new_serve_time: 'Nova hora de serviço:',
  },
  buttons: {
    print: 'Imprimir e Fechar',
    got_it: 'Entendido',
  },
  feedback: {
    new_prep_time: 'O tempo de entrega foi atualizado. Por favor ajuste o seu plano de preparação.',
  },
  toasts: {
    something_went_wrong: 'Algo correu mal, por favor tente novamente',
  },
};
